
import request from "@/utils/request";
import { Boutique } from '@/enum/index'


export function getAppLatest() {
    return request.post('/app/v1/appVersion/getLatest')
}

